import { render, staticRenderFns } from "./VInfo.vue?vue&type=template&id=1fe06054&scoped=true&lang=pug"
import script from "./VInfo.vue?vue&type=script&lang=js"
export * from "./VInfo.vue?vue&type=script&lang=js"
import style0 from "./VInfo.vue?vue&type=style&index=0&id=1fe06054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe06054",
  null
  
)

export default component.exports